<template>
  <div class="welfare_dialog_overlay" v-if="show" :style="{ '--img': `url('${backgroundImage}')` }"
    @click="handleClickOverlay">
    <div class="content_wrap" @click.stop="() => { }">
      <div class="title">{{ title || $t("welfareDialogTitle") }}</div>
      <div class="contents">{{ content }}</div>
      <div class="btn_wrap">
        <div class="btn" @click="read">{{ $t("Button.confirm") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { READ_NOTICE } from "@tt/api";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    msgId: {
      type: String | Number,
      default: "",
    },
    next: false,
    clickOverlay: {
      type: Boolean,
      default: true
    },
    backgroundImage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      welfareDialogContent: "",
    };
  },
  model: {
    prop: "show",
    event: "updateShow",
  },
  methods: {
    done() {
      this.$emit("updateShow", false);
    },
    handleClickOverlay() {
      if (this.clickOverlay) {
        this.$emit("updateShow", false);
      }
    },
    async read() {
      this.done();
      try {
        const { data: { next } } = await READ_NOTICE(this.msgId)
        this.$emit("read", this.next, next)
      } catch (error) {
        if (error.msg) {

        }
      }
      // this.$api.readNotice(this.msgId, (res) => {
      //   const {
      //     ret,
      //     data: { next },
      //   } = res.data;
      //   let params = {};
      //   if (ret === 1) params = next;

      //   this.$emit("read", this.next, params);
      // });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.welfare_dialog_overlay {
  max-width: 648px;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .content_wrap {
    padding: 16px;
    width: calc(90vw - 110px);
    max-width: calc((648px * 0.9) - 110px);
    height: calc(400px - 122px - 74px);
    // background-image: url("../assets/home/dialog_bg.png");
    // background-image: var(--img);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    background: #fff;
    border-radius: 10px;

    .title {
      font-weight: 700;
      font-size: 16px;
      text-align: center;
      color: #000;
    }

    .contents {
      height: 320px;
      padding: 12px 14px;
      padding-right: 6px;
      word-break: keep-all;
      overflow-wrap: break-word;
      overflow: hidden auto;
      // color: #371204;
      color: #07304a;
      line-height: 1;
      font-size: 18px;
      // font-weight: bold;
    }

    .btn_wrap {
      margin-top: 10px;
      display: flex;
      justify-content: center;

      .btn {
        background: linear-gradient(90deg, #8ff5d1, #31e2a5);
        color: #064b38;
        box-shadow: 0 9px 20px #31e2a547;
        font-weight: 600;
        font-size: 14px;
        height: 44px;
        width: 100%;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>